var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Dialog",
    {
      ref: "settingDialog",
      attrs: { title: "设置", width: "550px", "destroy-on-close": false },
    },
    [
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { staticClass: "video-view", attrs: { span: 12 } },
            [
              _c("el-row", [
                _c("div", { staticClass: "stream", attrs: { id: "stream" } }),
              ]),
              _vm._v(" "),
              _c(
                "el-row",
                [
                  _c("el-progress", {
                    attrs: {
                      percentage: _vm.percentageNum,
                      "show-text": false,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-row",
                [
                  _c("span", [_vm._v("摄像头")]),
                  _vm._v(" "),
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择" },
                      on: { change: _vm.changeVideo },
                      model: {
                        value: _vm.cameasActive,
                        callback: function ($$v) {
                          _vm.cameasActive = $$v
                        },
                        expression: "cameasActive",
                      },
                    },
                    _vm._l(_vm.cameras, function (item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.label, value: item.deviceId },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                [
                  _c("span", [_vm._v("麦克风")]),
                  _vm._v(" "),
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择" },
                      on: { change: _vm.changeAudio },
                      model: {
                        value: _vm.microphonesActive,
                        callback: function ($$v) {
                          _vm.microphonesActive = $$v
                        },
                        expression: "microphonesActive",
                      },
                    },
                    _vm._l(_vm.microphones, function (item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.label, value: item.deviceId },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                [
                  _c("span", [_vm._v("扬声器")]),
                  _vm._v(" "),
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择" },
                      on: { change: _vm.changeloudspeaker },
                      model: {
                        value: _vm.loudspeakerActive,
                        callback: function ($$v) {
                          _vm.loudspeakerActive = $$v
                        },
                        expression: "loudspeakerActive",
                      },
                    },
                    _vm._l(_vm.loudspeakers, function (item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.label, value: item.deviceId },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { type: "flex", justify: "end" } },
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.onSubmit } },
                    [_vm._v("确定切换")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.$refs.settingDialog.visible = false
                        },
                      },
                    },
                    [_vm._v("取消")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/views/classroom/components/settingsDialog.vue?vue&type=template&id=c8847f04&scoped=true&
// module id = null
// module chunks = 